// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"o5-z","dimensionLabel":"p5-z","styleChooserControlWrapper":"q5-z","styleChooserControl":"r5-z","disabled":"s5-z","giftCard":"t5-z","styleChooserText":"u5-z"};